// extracted by mini-css-extract-plugin
module.exports = {"unorderedList":"UnorderedList_unorderedList__spCEQ"};